import React from "react";

const toneClasses = {
  slate: "border-slate-200/80 bg-white dark:border-slate-700 dark:bg-white/5",
  indigo: "border-indigo-200/80 bg-indigo-50/55 dark:border-indigo-500/40 dark:bg-indigo-950/25",
  emerald: "border-emerald-200/80 bg-emerald-50/55 dark:border-emerald-500/40 dark:bg-emerald-950/25",
  amber: "border-amber-200/80 bg-amber-50/60 dark:border-amber-500/40 dark:bg-amber-950/25",
  rose: "border-rose-200/80 bg-rose-50/60 dark:border-rose-500/40 dark:bg-rose-950/25",
  sky: "border-sky-200/80 bg-sky-50/60 dark:border-sky-500/40 dark:bg-sky-950/25",
  violet: "border-violet-200/80 bg-violet-50/60 dark:border-violet-500/40 dark:bg-violet-950/25",
};

const iconToneClasses = {
  slate: "bg-slate-100 text-slate-600 dark:bg-slate-700/60 dark:text-slate-100",
  indigo: "bg-indigo-100 text-indigo-600 dark:bg-indigo-400/15 dark:text-indigo-200",
  emerald: "bg-emerald-100 text-emerald-600 dark:bg-emerald-400/15 dark:text-emerald-200",
  amber: "bg-amber-100 text-amber-600 dark:bg-amber-400/15 dark:text-amber-200",
  rose: "bg-rose-100 text-rose-600 dark:bg-rose-400/15 dark:text-rose-200",
  sky: "bg-sky-100 text-sky-600 dark:bg-sky-400/15 dark:text-sky-200",
  violet: "bg-violet-100 text-violet-600 dark:bg-violet-400/15 dark:text-violet-200",
};

export default function ChildInfoCard({ label, value, helper, action, tone = "slate", icon: Icon, className = "", onClick, ariaLabel }) {
  // With onClick the whole card is a button, e.g. to open the linked family or classroom.
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      {...(onClick ? { type: "button", onClick, "aria-label": ariaLabel } : {})}
      className={`rounded-[22px] border p-4 shadow-sm backdrop-blur transition hover:-translate-y-0.5 hover:shadow-md motion-reduce:hover:translate-y-0 ${
        onClick ? "w-full cursor-pointer text-left hover:border-indigo-300 focus:outline-none focus-visible:ring-4 focus-visible:ring-indigo-200 dark:hover:border-indigo-400/60 dark:focus-visible:ring-indigo-500/40" : ""
      } ${
        toneClasses[tone] || toneClasses.slate
      } ${className}`}
    >
      <div className="flex items-start gap-4">
        {Icon && (
          <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-xl ${iconToneClasses[tone] || iconToneClasses.slate}`}>
            <Icon aria-hidden="true" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-bold uppercase text-slate-500 dark:text-slate-400">{label}</p>
          <div className="mt-2 flex items-center gap-2">
            <div className="min-w-0 flex-1 break-words text-xl font-bold text-slate-950 dark:text-white">
              {value}
            </div>
            {action}
          </div>
          {helper && <p className="mt-3 text-sm leading-5 text-slate-500 dark:text-slate-400">{helper}</p>}
        </div>
      </div>
    </Wrapper>
  );
}
